<hyperkit-dialog class="hyperkit-component" headerText="Hunt Module">
  <div class="body">
    <div class="test">
      <div class="row column-one">
        <div class="content-wrapper">
          <img
            style="margin-right: 5px"
            width="24"
            height="24"
            src="/assets/img/icons/cyborg-premium.png"
          />
          <hyperkit-typography
            variant="body"
            size="md"
            align="left"
            color="body"
            >Want to learn more? Connect with us today to explore the Hunt
            Module features, accessible only to Premium
            subscribers.</hyperkit-typography
          >
          <div class="points">
            <ul>
              <li>
                <hyperkit-typography
                  variant="body"
                  size="md"
                  align="left"
                  color="body"
                  >Offer a space for teams to plan, execute, manage, and report
                  on hunts.</hyperkit-typography
                >
              </li>
              <li>
                <hyperkit-typography
                  variant="body"
                  size="md"
                  align="left"
                  color="body"
                  >Generate detailed reports providing stakeholders with
                  valuable insights.</hyperkit-typography
                >
              </li>
              <li>
                <hyperkit-typography
                  variant="body"
                  size="md"
                  align="left"
                  color="body"
                  >Develop structured templates to streamline the initiation,
                  customization, and execution of future
                  hunts.</hyperkit-typography
                >
              </li>
              <li>
                <hyperkit-typography
                  variant="body"
                  size="md"
                  align="left"
                  color="body"
                  >Gain clarity on the business impact of threat hunting
                  activities by tracking hunt KPIs and
                  Metrics.</hyperkit-typography
                >
              </li>
              <li>
                <hyperkit-typography
                  variant="body"
                  size="md"
                  align="left"
                  color="body"
                  >Full API access included.</hyperkit-typography
                >
              </li>
            </ul>
          </div>
          <hyperkit-button
            size="small"
            color="tertiary"
            text=" Talk to an Intel 471 Expert"
            (click)="talkToCyborg()"
          ></hyperkit-button>
        </div>
        <video
          loop
          controls
          oncanplay="this.play()"
          onloadedmetadata="this.muted = true"
        >
          <source
            src="https://go.intel471.com/hubfs/HUNTER%20Platform/Hunter%20Management%20Module.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  </div>
</hyperkit-dialog>
